import React from 'react'

import { Item, type ItemProps } from '../components/item'

export function isItemElement(
  element: React.ReactNode
): element is React.ReactElement<ItemProps> {
  return React.isValidElement(element) && element.type === Item
}
